import { createAction } from 'redux-actions';
import initialState from './initialState';
import formatActionTypeNames from '../helpers/formatActionTypeNames';

export const actions = formatActionTypeNames(
	{
		getConstants: 'GET_CONSTANTS',
		getConstantsComplete: 'GET_CONSTANTS_COMPLETE',
		setConstants: 'SET_CONSTANTS',
		getFeatureFlags: 'GET_FEATURE_FLAGS',
		getFeatureFlagsComplete: 'GET_FEATURE_FLAGS_COMPLETE',
		setFeatureFlags: 'SET_FEATURE_FLAGS',
		getMetaData: 'GET_META_DATA',
		getMetaDataComplete: 'GET_META_DATA_COMPLETE',
		setMetaData: 'SET_META_DATA',
		setMetaDataConstants: 'SET_META_DATA_CONSTANTS',
		getLogs: 'GET_LOGS',
		getLogsComplete: 'SET_LOGS',
		testEmail: 'TEST_EMAIL',
	},
	'SETTINGS'
);

export const settingsActions = {
	getConstants: createAction(actions.getConstants),
	getConstantsComplete: createAction(actions.getConstantsComplete),
	setConstants: createAction(actions.setConstants),

	getFeatureFlags: createAction(actions.getFeatureFlags),
	getFeatureFlagsComplete: createAction(actions.getFeatureFlagsComplete),
	setFeatureFlags: createAction(actions.setFeatureFlags),

	getMetaData: createAction(actions.getMetaData),
	getMetaDataComplete: createAction(actions.getMetaDataComplete),
	setMetaData: createAction(actions.setMetaData),
	setMetaDataConstants: createAction(actions.setMetaDataConstants),

	testEmail: createAction(actions.testEmail),
};

export default (state = initialState.settings, action) => {
	const { payload } = action;

	switch (action.type) {
		case actions.getFeatureFlagsComplete:
			return {
				...state,
				featureFlags: payload,
			};

		case actions.getConstantsComplete:
			return {
				...state,
				constants: {
					...state.constants,
					...payload,
				},
			};

		case actions.getMetaDataComplete:
			return {
				...state,
				metaData: payload,
			};

		case actions.getLogsComplete:
			return {
				...state,
				logs: payload,
			};

		default:
			return state;
	}
};
